import React from 'react'
import _ from 'lodash'
import { DeleteIcon } from "components/Icons";
import { Button } from 'antd';
import ModalUtil from 'utils/modalUtil';
import classnames from 'classnames';
import DeletePopup from './DeletePopup';
import { useActiveUserContext } from 'contexts/ActiveUserContext';
export default function DeleteButton({type = "icon", onDelete = _.noop, className, promptMessage, disabled, okText, note = true, confirmText, ...restProps}) {
    const activeUserData = useActiveUserContext();
    const onClick = () => {
        if(disabled){
            return ;
        }
        const _onDelete = (note) => onDelete(note, restProps.data)
        //Disable the all delete confirmation for user email 'dy@armorcode.io' with hardcoded string
        if (activeUserData.email === "dy@armorcode.io" || restProps.skipConfirm) {
            _onDelete(note);
            return;
        }

        ModalUtil.show({
            content: (
                <DeletePopup 
                    promptMessage={promptMessage}
                    note={confirmText ? false : note}
                    confirmText={confirmText}
                    okText={okText}
                    onDelete={_onDelete}
                />
            )
        })
    }
    if(type === "icon"){
        return <DeleteIcon className={classnames("danger clickable delete-icon", className, { disabled })}  {...restProps} onClick={onClick} />
    }
    return (
        <Button className={className} type="primary" danger {...restProps} disabled={disabled} onClick={onClick}>
            {restProps.children || "Delete"}
        </Button>
    )
}
DeleteButton.__ANT_BUTTON = true